module.exports = __webpack_public_path__ + "img/同济大学LOGO.db86064c.png";